export default "__VITE_ASSET__Ck5uJaqu__"